export default {
    id: null,
    descricao: null,
    pessoa: null,
}
